import React, { useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { IconButton, Tooltip } from '@material-ui/core';
import Fullscreen from '@material-ui/icons/Fullscreen';
import FullscreenExit from '@material-ui/icons/FullscreenExit';

const messages = defineMessages({
  FULL_SCREEN: {
    id: 'FULL_SCREEN',
    defaultMessage: 'Enter full screen',
  },
  EXIT_FULL_SCREEN: {
    id: 'EXIT_FULL_SCREEN',
    defaultMessage: 'Exit full screen',
  },
});

function FullScreenBtn() {
  const [isFullscreen, setFullscreen] = useState(false);

  const toggleFullScreen = () => {
    const elem = document.documentElement;

    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }

    function checkFullscreen() {
      const fullscreen = !!(document.fullscreenElement
        || document.mozFullScreenElement
        || document.webkitFullscreenElement
        || document.msFullscreenElement);
      setFullscreen(fullscreen);
    }

    setTimeout(() => { checkFullscreen(); }, 10);
    setTimeout(() => { checkFullscreen(); }, 100);
    setTimeout(() => { checkFullscreen(); }, 1000);
    setTimeout(() => { checkFullscreen(); }, 2000);
  };

  return isFullscreen ? (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.EXIT_FULL_SCREEN} />}>
      <IconButton onClick={toggleFullScreen}>
        <FullscreenExit />
      </IconButton>
    </Tooltip>
  ) : (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.FULL_SCREEN} />}>
      <IconButton onClick={toggleFullScreen}>
        <Fullscreen />
      </IconButton>
    </Tooltip>
  );
}

export default FullScreenBtn;
